import React from "react";
import { RecommendationProjectTypeEnum } from "../../../types";
import { useProjectTable } from "../hooks/useProjectTable";
import { ProjectTable } from "./table/ProjectTable";
import TagButtons from "./TagButtons";
import MangroveViewSelector from "./MangroveViewSelector";

/**
 * Refactored ProjectsTableV2 - Smart and simple table component
 * Now uses clean architecture with separated concerns
 */
const ProjectsTableV2: React.FC = () => {
  const {
    data,
    columns,
    selectedProject,
    selectedRecommendationType,
    loading,
    handleRowClick,
    handleRecommendationTypeChange,
    hasData,
    showRecommendationTabs,
  } = useProjectTable();

  if (!hasData && !loading) {
    const getEmptyMessage = () => {
      if (selectedProject === "recommendation") {
        const projectType =
          selectedRecommendationType === RecommendationProjectTypeEnum.Forests
            ? "forest"
            : "mangrove";
        return `No ${projectType} recommendations found`;
      }
      return "No projects found";
    };

    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-gray-500">{getEmptyMessage()}</div>
      </div>
    );
  }

  return (
    <div className="overflow-auto">
      {showRecommendationTabs && !loading && (
        <div className="flex items-center justify-between">
          <TagButtons
            tags={[RecommendationProjectTypeEnum.Mangroves, RecommendationProjectTypeEnum.Forests]}
            selectedTag={selectedRecommendationType}
            onTagClick={handleRecommendationTypeChange}
          />
          {selectedRecommendationType === RecommendationProjectTypeEnum.Mangroves && (
            <MangroveViewSelector className="mr-4" />
          )}
        </div>
      )}

      <ProjectTable
        projectType={selectedProject}
        data={data}
        columns={columns}
        onRowClick={handleRowClick}
        loading={loading}
      />
    </div>
  );
};

export default ProjectsTableV2;
